import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  makeStyles,
  TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

const useStyles = makeStyles({
  container: {
    minHeight: 50,
    overflow: 'hidden',
  },
  actions: {
    justifyContent: 'center',
  },
});

const ChangeDatesDemandForm = ({ initialValues, handleChangeDatesDemand, closeDialog }) => {
  const classes = useStyles();
  const { t } = useTranslation(['demands', 'common']);

  const validationSchema = Yup.object().shape({
    changeDatesReason: Yup.string().required(t('errors.change_dates_reason.required')),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleChangeDatesDemand}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Box className={classes.container} p={1}>
              <TextField
                fullWidth
                multiline
                rows={2}
                error={Boolean(touched.changeDatesReason && errors.changeDatesReason)}
                helperText={touched.changeDatesReason && errors.changeDatesReason}
                label={t('fields.change_dates_reason')}
                name="changeDatesReason"
                onBlur={handleBlur}
                onChange={handleChange}
                disabled={isSubmitting}
                value={values.changeDatesReason}
                variant="outlined"
              />
            </Box>
          </DialogContent>

          <DialogActions className={classes.actions}>
            <Button variant="contained" onClick={closeDialog}>
              {t('common:buttons.cancel')}
            </Button>

            <Button color="primary" variant="contained" onClick={handleSubmit}>
              {t('buttons.change_dates_demand')}
            </Button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
};

ChangeDatesDemandForm.propTypes = {
  initialValues: PropTypes.object,
  handleChangeDatesDemand: PropTypes.func,
  closeDialog: PropTypes.func,
};

export default ChangeDatesDemandForm;
